import React, { useCallback } from 'react';
import { TableRow, TableRowProps } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";

const ClickableTableRow: React.FC<ClickableTableRowProps & TableRowProps> = (props) => {
    const navigate = useNavigate();
    let onClick = props.onClick;
    const styles = useStyles();

    if (props.link) {
        onClick = useCallback(params => {
            props.onClick!(params);
            navigate(props.link!);
        }, [navigate, props.onClick]);
    }
    const disabledOnCLick = useCallback(e => e.stopPropagation(), []);

    return (
        <TableRow hover { ...props } onClick={ onClick } classes={ styles } sx={ { position: 'relative' } }>
            { props.children }
            {
                props.disabled &&
                <div
                    onClick={ disabledOnCLick }
                    style={ {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%', height: '100%',
                        backgroundColor: '#ffffff',
                        opacity: 0.5,
                    } }>
                </div>
            }

        </TableRow>
    );
}
export default ClickableTableRow;

export type ClickableTableRowProps = TableRowProps & {
    readonly link?: string;
    readonly disabled?: boolean;
}

const useStyles = makeStyles(theme => ({
    root: {
        cursor: 'pointer'
    }
}));